import React, { useRef } from "react";
import Slider from "react-slick";
import "./TestimonialsSection.css";
import jeevan from "../assets/jeevan.jpg";
import perira from "../assets/perira.jpg"
import sharat from "../assets/sharat.jpg"
import roydon from "../assets/roydon.jpg"
import soni from "../assets/soni.png"
import ayaan from "../assets/ayaan.png"
import mark from "../assets/athelete-2.png"

// Testimonial data with images
const testimonialData = [
  {
    name: "Mark Dcosta",
    role: "Sprint Athlete",
    rating: 5,
    review: "Well, After joining sports science I have improved my performance in just 3 months and have gained knowledge in anatomy and muscle better. I had knee pain which was lingering after past a year now had been proved a lot and now no pain at all and improved a lot and enhanced my over all performance. I wanna thank the sports science team for constant support and guidance.",
    image: mark
  },
  {
    name: "Aaron Pereira",
    role: "Athlete",
    rating: 4,
    review: "If you're an athlete who has recurrent injuries or is looking to improve their performance or simply wants to establish a baseline and track your progress, this place is for you. The staff here is very knowledgeable & friendly. Combined with state of the art equipment.. what could go wrong? They perform an initial assessment and give you an individualized work out plan all at a affordable rate.",
    image: perira
  },
  {
    name: "Sharath Acharya",
    role: "Athlete",
    rating: 4,
    review: "I had the opportunity to undergo physiotherapy at Aikyam Sports science after a shoulder injury that I sustained while playing cricket in Oman. Initially, my doctor had recommended surgery due to a bone crack, but after visiting Aikyam Sports science in India, the team assessed my condition and assured me that surgery wasn't necessary. They provided me with a personalized physiotherapy plan that focused on strengthening and rehabilitation.",
    image: sharat
  },
 {
    name: "Roydon Pinto",
    role: "Badminton Player",
    rating: 5,
    review: " As a badminton player and training at Aikyam has really helped me both on the court and off the court. They focus on improving your fitness, stamina, speed, and specific skills based on your sport. The best part is they have all the equipment, rehab sessions, and even physiotherapists to support you. It’s a great place for anyone into sports and looking to improve their performance.",
    image: roydon
  },
  {
    name: "Mayank Soni",
    role: "Athlete",
    rating: 5,
    review: "The Center for Sports Science is an outstanding facility for athletes, recovery management, and overall well-being. They have an in-house team of sports scientists, physiotherapists, and nutritionists, all highly qualified from reputed institutes and possessing commendable domain expertise.",
    image: soni
  },
  {
    name: "Ayaan Sheik",
    role: "Athlete",
    rating: 4,
    review: "I had an excellent experience with the Aikyam sports science staff. They are knowledgeable, caring, and always take time to explain each step of the treatment. I felt supported throughout my recovery, and the results have been amazing.Thank you to the Aikyam sports science",
    image: ayaan
  },
  {
    name: "Sarthak Kapil",
    role: "Athlete",
    rating: 5,
    review: "Amazing service, very knowledgable trainers, practical sessions, personalised advice for continuing at home or travel too.One of the best and most honest, helpful staff I’ve seen.The doctor helped me understand the root cause for my shoulder dislocation that I had incurred during surfing. She patiently guided me throughout and recommended the perfect exercises for complete recovery.",
    image: jeevan
  },
];


const TestimonialsSection = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, idx) => (
      <span key={idx} className={idx < rating ? "star-filled" : "star-empty"}>★</span>
    ));
  };

  return (

    <section className="testimonials-section" id="success">
      <div className="testimonials-header">
        <h2>
           What our <span className="testimonials-highlight-text">Customers Say</span>
        </h2>
        {/* <div className="testimonials-arrow-buttons">
          <button className="testimonials-arrow-btn" onClick={() => sliderRef.current.slickPrev()}>
            ←
          </button>
          <button className="testimonials-arrow-btn" onClick={() => sliderRef.current.slickNext()}>
            →
          </button>
        </div> */}
      </div>

      <Slider {...settings} ref={sliderRef}>
        {testimonialData.map((testimonial, idx) => (
          <div className="testimonials-card-wrapper" key={idx}>
            <div className="testimonials-card">
              <p className="testimonials-review">{testimonial.review}</p>
              <div className="testimonials-user-info">
                <img src={testimonial.image} alt={`${testimonial.name} avatar`} className="testimonials-avatar" />
                <div className="testimonials-details">
                  <h4>
                    {testimonial.name} (via Google Maps) <span className="testimonials-rating">{renderStars(testimonial.rating)}</span>
                  </h4>
                  <p>{testimonial.role}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default TestimonialsSection;